/** Enum defining the media queue types. */
enum MediaQueueType {
  /** A media type representing an album. */
  ALBUM = 'album',

  /** A media type representing an audio book. */
  AUDIO_BOOK = 'audioBook',

  /** A media type representing a live TV. */
  LIVE_TV = 'liveTv',

  /** A media type representing a movie. */
  MOVIE = 'movie',

  /** A media type representing an audio playlist. */
  PLAYLIST = 'playlist',

  /** A media type representing a radio station. */
  RADIO_STATION = 'radioStation',

  /** A media type representing a podcast series. */
  PODCAST_SERIES = 'podcastSeries',

  /** A media type representing a TV series. */
  TV_SERIES = 'tvSeries',

  /** A media type representing a video playlist. */
  VIDEO_PLAYLIST = 'videoPlaylist',
}

export default MediaQueueType
